module.exports = __webpack_public_path__ + "static/media/sanitaria-01.9b521b92.jpg";